export const environment = {
  production: false,
  envName: 'dev',
  CONFIG_FILE: 'assets/config/env.json',
  BASEHREF: '/cfc-web',
  API_MAPS: 'AIzaSyAKPfvmojNFpegFImWVbxrf72sUrhQ6j2k',
  TINY_MCE: 'ps816aetpgcg8rrf7a7zz4h7jv0lfeumju4nokqwu4vrguq4'
}
